(function ($) {

    window.resizeColorBox = function () {
        if (window.resizeTimer) clearTimeout(window.resizeTimer);
        window.resizeTimer = setTimeout(function () {
            if (($('#cboxOverlay').is(':visible')) && (ssm.isActive('tablet'))) {
                $.colorbox.resize({ width: '100%', height: '100%' })
            }
        }, 300);
    };

    // Resize Colorbox when resizing window or changing mobile device orientation
    $(window).resize(window.resizeColorBox);
    window.addEventListener("orientationchange", window.resizeColorBox, false);

    $(function () {

        // ghost title focus and blur behaviour
        $(document.body)
            .on("focusout", ".optional-input", function (e) {
                if ($(this).val()) {
                    $(this).css("background", "white");
                } else {
                    $(this).css("background", "#f1f1f1");
                }
            });

        $(document).on('cbox_open', function () {
            $("body").addClass('box-open');
        }).on('cbox_closed', function () {
            $("body").removeClass('box-open');
        });

        $('a.gallery').colorbox({
            rel: 'gal',
            current: "<i class='fa fa-camera' aria-hidden='true'></i> {current}/{total}",
            maxWidth: '95%',
            maxHeight: '80%',

            scalePhotos: true,
            className: 'listingGallery',
            title: function () {
                return $(this).find("img").attr("title");
            },
            alt: function () {
                return $(this).find("img").attr("alt");
            }

        });
    });

    function accordionOpen($link, $inner, $outer, $container) {
        jQuery($link).on('click', function () {
            var container = jQuery(this).parents($container);
            event.preventDefault();
            if (ssm.isActive('tablet')) {
                // Check if the accordion is already active //
                if (jQuery(this).hasClass('active')) {
                    container.find($inner).removeClass('active').stop(true, true);
                    container.find($link).removeClass('active');
                } else {
                    container.find($inner + '.active').removeClass('active').stop(true, true);
                    container.find($link + '.active').removeClass('active');
                    jQuery(this).addClass('active');

                    // Slide the new accordion down and scroll to the top of it //
                    jQuery(this).parents($outer).find($inner).addClass('active').stop(true, true);
                    jQuery(this).parents($outer).find($inner).promise().done(function () {
                        var target = jQuery(this).parents($outer);
                        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            $('html,body').animate({
                                scrollTop: target.offset().top
                            }, 1000);
                            return false;
                        }
                    });
                }
            }
            return false;
        });
    }

    accordionOpen('.collapse-link', '.collapse-content', '.collapse-section', '.collapse-wrapper');

    window.showColorbox = function (show) {
        $.colorbox({
            inline: true, href: show, maxWidth: "90%"
        });
    };

    window.hideNotification = function () {
        $("body").addClass('snack-notification-inactive');
        $('.snack-notification').addClass('remove-notification')
            .one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (e) {
                $(this).hide().removeClass('remove-notification');
                $("body").removeClass('snack-notification-active').removeClass('snack-notification-inactive');
            });
    };
})(jQuery);